export const reservationsConstants = {
  RESERVATIONS_INIT: '[Reservations] init',
  RESERVATIONS_UPDATE: '[Reservations] Update',
  RESERVATIONS_REMOVE: '[Reservations] Remove',
  RESERVATIONS_BOOK: '[Reservations] Book',
  RESERVATIONS_BOOK_SUCCESS: '[Reservations] Book success',
  RESERVATIONS_BOOK_FAILURE: '[Reservations] Book failure'
}
